import Antd, {Message, Notification, Modal} from "@/components/antd";
import {Icon} from "@/components/icon";
import Animation from "@/components/animation";
import Body from "./body";
import Title from "./title";
import TooltipIfOverflow from "./TooltipIfOverflow";

export {
    Antd,
    Message,
    Notification,
    Modal,
    Icon,
    Animation,
    Body,
    Title,
    TooltipIfOverflow
}
